import { render, staticRenderFns } from "./WidgetAccordionItem.vue?vue&type=template&id=6e590368&scoped=true"
import script from "./WidgetAccordionItem.vue?vue&type=script&lang=js"
export * from "./WidgetAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./WidgetAccordionItem.vue?vue&type=style&index=0&id=6e590368&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e590368",
  null
  
)

export default component.exports